import { Reducer } from '@reduxjs/toolkit';

const filtersReducer: Reducer = (state, { payload }) => {
  if (payload === null) {
    return {
      ...state,
      filters: {
        globalFilter: '',
        filters: [],
      },
    };
  }

  const isFilters = Array.isArray(payload);

  return {
    ...state,
    filters: {
      globalFilter: isFilters ? state.filters.globalFilter : payload,
      filters: isFilters ? payload : state.filters.filters,
    },
  };
};

export default filtersReducer;
